import Vue from 'vue'
// import { login } from '@/api/login'
import { USERNAME, USER_ID, COMPANY_ID, TRAVELLEVELDATA } from '@/store/mutation-types'

const user = {
  state: {
    token: '',
    username: '',
    userId: '',
    companyId: '',
    info: ''
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      state.token = payload
    },
    SET_USERNAME: (state, username) => {
      state.username = username
      Vue.ls.set(USERNAME, username)
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
      Vue.ls.set(USER_ID, userId)
    },
    SET_COMPANY_ID: (state, companyId) => {
      state.companyId = companyId
      Vue.ls.set(COMPANY_ID, companyId)
    },
    SET_TRAVELLEVEL: (state, info) => {
      state.info = info
      Vue.ls.set(TRAVELLEVELDATA, info)
    }
  },
  actions: {
    // 登录
    // Login ({ commit }, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     login(userInfo).then(res => {
    //       Vue.ls.set(ACCESS_TOKEN, res.data.access_token, 7 * 24 * 60 * 60 * 1000)
    //       commit('SET_TOKEN', res.data.access_token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/login.js